import { Component, Vue, Watch } from 'vue-property-decorator';
import { getModule} from 'vuex-module-decorators';
import axios, {AxiosPromise}  from 'axios';

import User from "@/module/store/user";
import {CONFIG_ENV} from '@/config';
import AlegereEveniment from "@/components/AlegereEveniment/AlegereEveniment"
import AlegereSaTeImplici from "@/components/AlegereSaTeImplici/AlegereSaTeImplici"
import MergiLaSigur from "@/components/MergiLaSigur/MergiLaSigur"

import { scroll } from 'quasar';
const { getScrollTarget, setScrollPosition } = scroll;

interface Ipages{
    id:number,
    componentName:string,
    prevId:number,
    nextId:number
}

@Component({components:{AlegereEveniment,AlegereSaTeImplici,MergiLaSigur}})
export default class MainPage extends Vue {
    loading:boolean=false;
    currentPageComponent:string='MergiLaSigur';
    info:string='';
    currentPageId:number=1;
    arrPages:Array<Ipages>=[
        {
            id:1,
            componentName:'MergiLaSigur',
            prevId:3,
            nextId:2
        }
        ,{
            id:2,
            componentName:'AlegereEveniment',
            prevId:1,
            nextId:3
        }
        ,{
            id:3,
            componentName:'AlegereSaTeImplici',
            prevId:2,
            nextId:1
        }
    ];

    $refs:any;
    private userStore=getModule(User);



    constructor(){
        super();
    }

    scrollToElementById(p_id_of_element:string){
        const el: HTMLElement = document.getElementById(p_id_of_element)!;
        const target = getScrollTarget(el)
        const offset = el.offsetTop
        const duration = 300;
        setScrollPosition(target, offset, duration);
    }

    handleSwipeFirstImage ({ evt, ...info }:any) {
        let vueInst=this;
        if(info.direction=='up'){//prev Page
            vueInst.scrollToElementById('div_on_top_of_alegere_eveniment');
        }
    }


    handleSwipe ({ evt, ...info }:any) {
        let vueInst=this;

        if(info.direction=='up'||(info.direction=='left' && vueInst.currentPageComponent!='AlegereEveniment')){//next Page
            const currentPageComp=vueInst.arrPages.find((pelement:Ipages)=>{
                return pelement.id==vueInst.currentPageId;
            });
            if(currentPageComp){
                //console.log('setam currentPageComp=%o',currentPageComp)
                vueInst.currentPageId=currentPageComp.nextId;

                const nextPageComp=vueInst.arrPages.find((pelement:Ipages)=>{
                    return pelement.id==currentPageComp.nextId;
                });
                if(nextPageComp) {
                    vueInst.currentPageComponent=nextPageComp.componentName;
                }
            }
        }

        if(info.direction=='down'||(info.direction=='right' && vueInst.currentPageComponent!='AlegereEveniment')){//prev Page
            const currentPageComp = vueInst.arrPages.find((pelement: Ipages) => {
                return pelement.id == vueInst.currentPageId;
            });
            if (currentPageComp) {
                //console.log('setam currentPageComp=%o',currentPageComp)
                vueInst.currentPageId = currentPageComp.prevId;

                const nextPageComp = vueInst.arrPages.find((pelement: Ipages) => {
                    return pelement.id == currentPageComp.prevId;
                });
                if (nextPageComp) {
                    vueInst.currentPageComponent = nextPageComp.componentName;
                }
            }
        }

        this.info = info;

        // native Javascript event
        // console.log(evt)
    }
}
